export default "__VITE_ASSET__BHyCNpRN__"